// extracted by mini-css-extract-plugin
export default {"popover-root":"_2bl1v","popoverRoot":"_2bl1v"};